import relevanceBundle from './data/relevanceV2CompactAuthored.json';

export type RelevanceV2Section = {
  title: string;
  body: string;
};

export type RelevanceV2Compact = {
  intro: string;
  sections: RelevanceV2Section[];
  note: string | null;
  rule?: string;
};

type RelevanceV2Row = {
  authoring_id: string;
  chart_id: string;
  view_id: string;
  relevance: RelevanceV2Compact;
};

const rows = relevanceBundle as RelevanceV2Row[];

const byKey = new Map<string, RelevanceV2Compact>();
for (const row of rows) {
  const key = `${row.chart_id}|${row.view_id}`;
  if (!byKey.has(key)) {
    byKey.set(key, row.relevance);
  }
}

/** Exact-authored Relevance V2 compact copy by chart + view (no generation). */
export function resolveRelevanceV2(chartId: string, viewId: string): RelevanceV2Compact | null {
  return (
    byKey.get(`${chartId}|${viewId}`) ??
    byKey.get(`${chartId}|default`) ??
    null
  );
}

export function listRelevanceV2AuthoredKeys(): string[] {
  return Array.from(byKey.keys()).sort();
}
